import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { House } from "@mui/icons-material";
import meetMark  from "../images/about_deb_bg.jpg";

const ElevatingOurVoices = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetMark })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <House sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Elevating Our Voices
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Mark will continue to ensure your voices are heard and you are listened to when you raise concerns. Mark prides herself on being responsive to her community when they ask for help. She attends meetings, rallies, and events where her presence can assist with your cause. She is dedicated to finding the best possible solution to the community’s requests, even if she meets fierce resistance.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Spearheaded the expansion of the Aging-In-Place tax credit to assist seniors who wish to remain in their homes." />
              <Bullet text="Requested and received funding for a new noise monitor position at Merriweather Post Pavilion to address concerts that exceed allowed decibel levels." />
              <Bullet text="Lobbied against the conversion of beloved park space for a fire station and moved budget funds into a reserve account until a more suitable location was determined." />
              <Bullet text="Advocated and supported funding for the expansion of the Howard County Medical Center for more behavioral health and emergency room services." />
              <Bullet text="Advocated and supported funding for a community center in Wilde Lake." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default ElevatingOurVoices;
